import { Piece, PieceAction, PieceType, UpdatePieceRequest } from '@apiContract';

import { mailpieceActions } from './index';
import { CombinedActions, CommonAction, ValidationData } from './types';

// parse pieces ids this way only if validation could be applied
export const buildValidationPieces = (mailpieces: Piece[], validationData?: ValidationData): UpdatePieceRequest[] =>
  mailpieces.map((piece) => ({ id: piece.id, ...validationData?.[piece.id] }));

export const getItemsCount = (mailpieces: { length: number }) => (mailpieces.length > 1 ? mailpieces.length : 0);

export const isPickUpLessCurrentDate = (pickUpDate: Date) => {
  const clonePickUpDate = new Date(pickUpDate.getTime());
  const currentDate = new Date();

  clonePickUpDate.setSeconds(0, 0);
  currentDate.setSeconds(0, 0);

  return clonePickUpDate.getTime() < currentDate.getTime();
};

export const isGroupEnabled = (group: CombinedActions, settings: Record<string, boolean>): boolean => {
  const settingName = mailpieceActions[group]?.validationSettingName;
  return typeof settingName === 'string' && settings[settingName];
};

const DISPLAY_ORDER_FIRST: CommonAction[] = [PieceAction.Assign, PieceAction.Submit];

export const getActionDisplayPriority = (action: CommonAction): number => {
  if (action === PieceAction.Delete) return DISPLAY_ORDER_FIRST.length + 1;
  const index = DISPLAY_ORDER_FIRST.indexOf(action);
  return index === -1 ? DISPLAY_ORDER_FIRST.length : index;
};

// Collapses each grouped action into its combined action, derived from the group field on the
// action config — but only when the group's validation setting is enabled.
export const combineActions = (
  actions: PieceAction[],
  settings: Record<string, boolean>,
  pieceType: PieceType,
): CommonAction[] => {
  const result: CommonAction[] = [];
  const addedGroups = new Set<CombinedActions>();

  actions.forEach((action) => {
    const group = mailpieceActions[action]?.group;

    if (group === undefined || pieceType === PieceType.Mail || !isGroupEnabled(group, settings)) {
      result.push(action);
      return;
    }

    if (!addedGroups.has(group)) {
      addedGroups.add(group);
      result.push(group);
    }
  });

  return result;
};
